const serverUrl = process.env.VUE_APP_API;

const getURLFile = (filePath) => {
  return `${serverUrl}/api/file/get/${filePath}`;
};

export default getURLFile;
